import { render, staticRenderFns } from "./ProductSearchPage.vue?vue&type=template&id=2040603e&scoped=true&lang=pug&"
import script from "./ProductSearchPage.vue?vue&type=script&lang=ts&"
export * from "./ProductSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearchPage.vue?vue&type=style&index=0&id=2040603e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040603e",
  null
  
)

export default component.exports